import React from "react";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "../ui/drawer";
import { EmergencyTypeGrid } from "../EmergencyTypeGrid";

/**
 * Step 1 of the citizen arm-then-send flow: pick one or more
 * emergency types. Drawer is controlled by the parent via `open`.
 */
export const HomeTypeDrawer = ({ open, onOpenChange, types, onTypesChange, onContinue, t }) => (
  <Drawer open={open} onOpenChange={onOpenChange}>
    <DrawerContent className="bg-card" data-testid="type-modal">
      <DrawerHeader className="text-left pb-2">
        <DrawerTitle className="text-mali-navy dark:text-white font-display text-xl font-black tracking-tight">
          {t.emergencyType}
        </DrawerTitle>
        <DrawerDescription className="text-xs text-muted-foreground mt-1">
          {t.multiTypeHint || "Sélectionnez un ou plusieurs types."}
        </DrawerDescription>
      </DrawerHeader>
      <div className="px-4 pb-4 max-h-[60vh] overflow-y-auto">
        <EmergencyTypeGrid value={types} onChange={onTypesChange} />
      </div>
      <div className="px-4 pb-6 pt-2 flex gap-2">
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          data-testid="type-modal-cancel"
          className="flex-1 bg-muted text-foreground font-bold text-sm py-3.5 rounded-xl hover:bg-muted/70 transition-colors"
        >
          {t.cancel || "Annuler"}
        </button>
        <button
          type="button"
          onClick={onContinue}
          data-testid="type-modal-continue"
          disabled={types.length === 0}
          className={
            "flex-[2] font-bold text-sm py-3.5 rounded-xl transition-all " +
            (types.length === 0
              ? "bg-muted text-muted-foreground cursor-not-allowed"
              : "bg-mali-red text-white shadow-md shadow-mali-red/30 hover:opacity-95 active:scale-[0.99]")
          }
        >
          {t.continueCta || "Continuer"}{types.length > 0 ? ` (${types.length})` : ""}
        </button>
      </div>
    </DrawerContent>
  </Drawer>
);
